/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type SoftwareOnboardingPageType from '@jira/spa-apps__software-onboarding/src/index.server.tsx';
import type { SoftwareOnboardingPageProps } from '@jira/spa-apps__software-onboarding/src/index.server.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazySoftwareOnboardingPage: LazyComponent<
	({ jiraOnboardingContextFragment }: SoftwareOnboardingPageProps) => React.JSX.Element
> = lazyForPaint<typeof SoftwareOnboardingPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-software-onboarding", jiraSpaEntry: "async-software-onboarding" */ '@jira/spa-apps__software-onboarding/src/index.tsx'
		),
	),
);

export const SoftwareOnboardingPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazySoftwareOnboardingPage}
		pageId="software-onboarding"
		shouldShowSpinner={false}
	/>
);
